/**
 * Extrae el nombre de host de una URL
 * @param url La URL de la que extraer el nombre de host
 * @returns El nombre de host de la URL
 */
export const extractHostname = (url: string): string => {
  try {
    // Usar el objeto URL del navegador
    const urlObj = new window.URL(url);
    return urlObj.hostname;
  } catch (error) {
    // Si la URL no es válida, devolver la URL original
    return url;
  }
};
